import {AlertController, IonButton, IonSelect, ModalController} from '@ionic/angular';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import {BarcodeFormat} from '@zxing/library';
import {DocumentModel} from 'src/app/models/document.model';
import {ScanBarcodeService} from 'src/app/services/scan-barcode.service';
import {DetaillineDTOModel} from 'src/app/models/detaillineDTO.model';
import {GeneralService} from 'src/app/services/general.service';
import {BarcodeFormatModel} from 'src/app/models/barcode-format.model';
import {ScreenPreferencesModel} from '../../models/screen-preferences.model';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';

@Component({
    selector: 'app-barcodescanner',
    templateUrl: './barcodescanner.component.html',
    styleUrls: ['./barcodescanner.component.scss'],
})

export class BarcodescannerComponent implements OnInit {

    @Input() document: DocumentModel;
    @ViewChild('scanner') scanner: ZXingScannerComponent;
    @ViewChild('barcodeFormatSelect') barcodeFormatSelect: IonSelect;
    @ViewChild('torchButton') torchButton: IonButton;
    hasCameras = false;
    hasPermission: boolean;
    qrResultString: string;
    availableDevices: MediaDeviceInfo[];
    selectedDevice: MediaDeviceInfo = null;
    barcodeMediaDevices: MediaDeviceInfo[] = [];
    enabled: Boolean = false;
    screenPreferences: ScreenPreferencesModel;
    bcFormat: BarcodeFormatModel;
    allowedFormats: any = [];
    torchEnabled = false;
    mobileConfig: MobileConfigurationModel;
    willScan = true;

    constructor(public modalController: ModalController,
                private scanBarcodeService: ScanBarcodeService,
                private generalService: GeneralService,
                private alertController: AlertController,
                private androidPermissions: AndroidPermissions,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private findEquipmentPriceService: FindEquipmentPriceService) {
    }

    ngOnInit() {
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        console.log(BarcodeFormat.AZTEC);
    }

    ionViewWillEnter() {
        this.screenPreferences = this.stateManager.getCollection(this.collectionNames.SCREENPREFERENCES);
    }

    ionViewDidEnter() {
        this.scanner.askForPermission();
        // if (!window.cordova) {
        // }
        this.createBarcodeFormat();
        this.setTorchButtonColor();
    }

    isBarcodeReaderLive() {
        const interval = setInterval(() => {
            clearInterval(interval);
            this.torchEnabled = this.screenPreferences.barcodeTorchEnabled;
            console.log('interval fired');
        }, 1000);

    }


    async closeModal() {
        await this.modalController.dismiss();
    }

    onCamerasFound(devices: MediaDeviceInfo[]) {
        console.log('On Cameras found devices');
        console.log(devices);
        console.log('------------------------');

        this.barcodeMediaDevices = devices;

        this.selectCamera();
        this.isBarcodeReaderLive();
    }

    selectCamera() {
        console.log(this.screenPreferences.selectedBarcodeDevice);
        if (!this.screenPreferences.selectedBarcodeDevice) {
            this.screenPreferences.selectedBarcodeDevice = this.barcodeMediaDevices[0];
            this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
        }

        const refresh = JSON.parse(JSON.stringify(this.screenPreferences.selectedBarcodeDevice));
        this.screenPreferences.selectedBarcodeDevice = null;
        this.screenPreferences.selectedBarcodeDevice = refresh;
        this.selectedDevice = null;
        for (const device of this.barcodeMediaDevices) {
            if (device.label === this.screenPreferences.selectedBarcodeDevice.label) {
                this.selectedDevice = device;
            }
        }
        this.hasCameras = Boolean(this.barcodeMediaDevices && this.barcodeMediaDevices.length);
        this.enabled = true;
    }

    onHasPermission(has: boolean) {
        console.log('I got permission');
        this.hasPermission = has;
    }

    createBarcodeFormat() {
        for (const n in BarcodeFormat) {
            if (typeof BarcodeFormat[n] === 'string') {
                const bcFormat = {
                    description: 'BarcodeFormat.' + BarcodeFormat[n],
                    shortDescription: BarcodeFormat[n]
                };
                this.allowedFormats.push(bcFormat);
            }
        }
    }

    barcodeFormatCompare(f1: BarcodeFormatModel, f2: BarcodeFormatModel): boolean {
        return f1 && f2 ? f1.description === f2.description : f1 === f2;
    }

    onTorchCompatible(event) {

    }

    saveConfig() {
        console.log(this.screenPreferences);
        this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
        this.selectCamera();
    }

    mediaDeviceCompare(m1: MediaDeviceInfo, m2: MediaDeviceInfo): boolean {
        return m1 && m2 ? m1.label === m2.label : m1 === m2;
    }

    openBarcodeFormat() {
        this.barcodeFormatSelect.open();
    }

    handleClickingTorch() {
        this.screenPreferences.barcodeTorchEnabled = !this.screenPreferences.barcodeTorchEnabled;
        this.torchEnabled = this.screenPreferences.barcodeTorchEnabled;
        this.setTorchButtonColor();
        this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
    }

    setTorchButtonColor() {
        this.torchButton.color = this.screenPreferences.barcodeTorchEnabled ? 'primary' : 'light';
    }

    async handleScanResult(event) {
        console.log('Scan Result');
        console.log(event);
        if (this.willScan) {
            let equipment = this.scanBarcodeService.findPlantItemByExactBarcode(event) as DetaillineDTOModel;
            if (equipment) {
                if (!equipment.qty) {
                    equipment.qty = 1;
                }
                this.willScan = false;
                equipment = JSON.parse(JSON.stringify(equipment));
                await this.confirmEquipment(equipment);
            } else {
                this.generalService.createToast('No match with barcode: ' + event);
            }
        }
    }

    async confirmEquipment(equipment) {
        const alert = await this.alertController.create({
            header: 'Equipment found',
            message: 'Do you want to add \n' + equipment.description + '\nto the document?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.willScan = true;
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.handleEquipmentFoundWithBarcode(equipment);
                    }
                }
            ]
        });
        await alert.present();
    }

    handleEquipmentFoundWithBarcode(equipment: any) {
        if (this.mobileConfig.mobilehireHealthCareInUse === 1) {
            if (this.document.parentDocument) {
                if (this.checkItemPresentInOrder(equipment)) {
                    this.checkSpecificFulfilment(equipment);
                } else {
                    this.generalService.createToast('Item not present in the order');
                }
            } else {
                const pushEquip = this.findEquipmentPriceService.getChargeLineAndDiscount(equipment, this.document.customer);
                pushEquip.fromDate = new Date().toISOString();
                pushEquip.toDate = new Date().toISOString();
                console.log('PushEquip');
                console.log(pushEquip);
                this.document.detailLines.push(pushEquip);
            }
        } else {
            // If it is a service job it behaves differently
            // It'll assign the equipement to the service job instead
            if (this.document.documentType === 7) {
                this.modalController.dismiss(equipment);
            } else {
                const pushEquip = this.findEquipmentPriceService.getChargeLineAndDiscount(equipment, this.document.customer);
                pushEquip.fromDate = new Date().toISOString();
                pushEquip.toDate = new Date().toISOString();
                console.log('PushEquip');
                console.log(pushEquip);
                this.document.detailLines.push(pushEquip);
            }
        }
        this.willScan = true;
    }

    // async assignCustomer(equipment: DetaillineDTOModel) {
    //     this.document.customer = await this.stateManager.getCollection('customer').chain().find({id: equipment.custId}).data()[0];
    //     if (!this.document.customer) {
    //         this.document.customer = new CustomerModel();
    //     }
    // }

    checkItemPresentInOrder(tempEquip: DetaillineDTOModel): boolean {
        let itemPresent = false;
        for (const line of this.document.parentDocument.detailLines) {
            if (line.pdesc === tempEquip.pdesc) {
                itemPresent = true;
                break;
            }
        }
        return itemPresent;
    }

    private checkSpecificFulfilment(tempEquip: DetaillineDTOModel) {
        let itemFulfilled = false;
        for (const line of this.document.parentDocument.detailLines) {
            console.log(line);
            if (line.pdesc === tempEquip.pdesc && this.checkFulfillment(tempEquip) < line.qty) {
                const tempDetailLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
                // tempDetailLine = this.findEquipmentPriceService.getChargeLineAndDiscount(line, this.document.customer);
                tempDetailLine.originalDetailLine = JSON.parse(JSON.stringify(line));
                tempDetailLine.documentNumber = null;
                tempDetailLine.detailLineId = 0;
                tempDetailLine.reg = tempEquip.reg;
                tempDetailLine.qty = 1;
                tempDetailLine.typ = tempEquip.typ;
                tempDetailLine.contractDocumentNumber = this.document.parentDocument.documentNumber;

                this.document.detailLines.push(tempDetailLine);
                itemFulfilled = true;
                break;
            }
        }
        if (!itemFulfilled) {
            this.generalService.createToast('Item already fulfilled');
        } else {
            this.checkIfOrderAlreadyFulfilled();
        }
    }

    checkFulfillment(item: DetaillineDTOModel) {
        let count = 0;
        for (const line of this.document.detailLines) {
            if (line.pdesc === item.pdesc) {
                count += line.qty;
            }
        }
        return count;
    }


    private checkIfOrderAlreadyFulfilled() {
        let fulfilled = true;
        for (const line of this.document.parentDocument.detailLines) {
            if (this.checkFulfillment(line) < line.qty) {
                fulfilled = false;
                break;
            }
        }
        if (fulfilled) {
            this.modalController.dismiss();
        }
    }
}
